function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.2,
  x: -0.5,
  y: -0.5,
  width: 45,
  height: 45,
  rx: 22.5,
  transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 45 45)",
  fill: "#B5B5B5",
  stroke: "#DFDFE8"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: -0.5,
  y: -0.5,
  width: 34.7778,
  height: 34.7778,
  rx: 17.3889,
  transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 39.8889 39.8887)",
  fill: "#A8AAAC",
  stroke: "#DFDFE8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.4128 29.0942C24.8209 29.4874 25.4808 29.4874 25.8889 29.0942C26.2963 28.701 26.2963 28.0638 25.8889 27.6706L21.0468 23.0006L25.8889 18.3298C26.2963 17.9366 26.2963 17.2994 25.8889 16.9062C25.4808 16.513 24.8209 16.513 24.4128 16.9062L18.8333 22.2888C18.4259 22.682 18.4259 23.3191 18.8333 23.7124L24.4128 29.0942Z",
  fill: "white"
});

function SvgCaretLeftDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeftDisabled);
export default __webpack_public_path__ + "static/media/caret_left_disabled.66813d78.svg";
export { ForwardRef as ReactComponent };